import Vue from 'vue';
import Router from 'vue-router';
import UniversalCharter from '../components/UniversalCharter';
import thanks from '../components/thanks';

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  routes: [
    {
      path: '/',
      name: 'UniversalCharter',
      component: UniversalCharter
    },
    {
      path: '/thanks',
      name: 'thanks',
      component: thanks,
      props: true // pass the params passed into the router push elsewhere in the code as properties
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js